<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
        {{indicator.departmentName}}
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="ngbActiveModal.close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <div class="d-flex flex-row justify-content-between">
        <form [formGroup]="formPeriod">
            <div class="btn-group">
                <div class="form-group">
                    <label for="year">
                        <span>Año</span>
                    </label>
                    <select class="form-control" id="year" formControlName="year">
                        <option value="" disabled>
                            <span>Choose year</span>
                        </option>
                        <option [ngValue]="2021">
                            2021
                        </option>
                        <option [ngValue]="2022">
                            2022
                        </option>
                        <option [ngValue]="2023">
                            2023
                        </option>
                        <option [ngValue]="2024">
                            2024
                        </option>
                        <option [ngValue]="2025">
                            2025
                        </option>
                        <option [ngValue]="2026">
                            2026
                        </option>
                        <option [ngValue]="2027">
                            2027
                        </option>
                        <option [ngValue]="2028">
                            2028
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="startAtPeriod">
                        <span>Desde</span>
                    </label>
                    <select class="form-control" id="startAtPeriod" formControlName="startsAt">
                        <option value="" disabled>
                            <span>Fecha</span>
                        </option>
                        <option [ngValue]="number" *ngFor="let number of numbers">
                            {{number}}
                        </option>
                    </select>
                </div>
                <div class="form-group">
                    <label for="endsAtPeriod">
                        <span>Hasta</span>
                    </label>
                    <select class="form-control" id="endsAtPeriod" formControlName="endsAt">
                        <option value="{{currentWeek}}" disabled>
                            <span>Fecha</span>
                        </option>
                        <option [ngValue]="number" *ngFor="let number of numbers">
                            {{number}}
                        </option>
                    </select>
                </div>
            </div>
        </form>
        <div class="btn-group" role="group">
            <button class="btn {{ periodType ? 'btn-success' : 'btn-info' }}" (click)="togglePeriod(true)">
                <span>Mes</span>
            </button>
            <button class="btn {{ !periodType ? 'btn-success' : 'btn-info' }}" (click)="togglePeriod(false)">
                <span>Semana</span>
            </button>
        </div>
        <div class="form-group">
            <button class="btn btn-info" (click)="setChartOptions()">
                <span>Obtener periodo</span>
            </button>
        </div>
    </div>
    <div #containerRef *ngIf="!isLoading && lineChartMulti">
        <google-chart [type]="'ComboChart'" [width]="containerRef.offsetWidth" [height]="600" [options]="optionsChart"
            [columns]="columnsChart" [data]="lineChartMulti">
        </google-chart>
    </div>
    <div class="row">
        <div class="col-lg-6 col-md-12 col-sm-12 col-xs-12">
          <div class="table-responsive">
                <table class="table table-sm table-bordered" >
                    <thead class="" style="background-color: #5D6B99 !important; color: #FFFFFF !important;margin-left: auto !important; margin-right: auto !important;">
                        <tr>
                            <th >
                                <span *ngIf="periodType">
                                    Meses
                                </span>
                                <span *ngIf="!periodType">
                                    Semanas
                                </span>
                            </th>
                            <th>Resultados</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let weekOrMonths of lineChartMulti; let index = index;">
                            <td>{{weekOrMonths[0]}}</td>
                            <td>{{returnFormat(weekOrMonths[1])}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
